<template>
    <section class="projects-section">
        <div class="container">
            <div class="projects-content">
                <!-- Left Column: Header + Filters -->
                <div class="projects-left-column">
                    <div class="projects-header">
                        <h2 class="section-title">{{ projectCount }} Projekte</h2>
                        <p class="section-subtitle">
                            Für Bruchköbel, Niederissigheim, Oberissigheim, Roßdorf und Butterstadt
                        </p>
                    </div>

                    <!-- Project Description -->
                    <div class="projects-description">
                        <p class="description-text">
                            "Ich setze mich dafür ein, dass unsere Stadt Schritt für Schritt lebenswerter wird – mit Projekten, die echte Veränderungen bringen. Ob neue Kitas, moderne Pflegeangebote, ein attraktives Stadtzentrum oder bessere Mobilität: Gemeinsam mit Ihnen gestalte ich Bruchköbel weiter – durchdacht, nachhaltig und mit Herz. Schauen Sie selbst, was bereits umgesetzt wurde – und was als Nächstes kommt."
                        </p>
                        
                        <!-- Projects Link -->
                        <div class="projects-link">
                            <button @click="goToProjects" class="projects-detail-link">
                                <span class="arrow">»</span>
                                <span class="link-text"> zu den Projekten</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Right Column: Map -->
                <div class="projects-map" @click="goToProjects" style="cursor: pointer;">
                    <InteractiveMap 
                        :clickable="false"
                        :draggable="false"
                        :scrollable="false"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import InteractiveMap from '@/components/InteractiveMap.vue'
import projectService from '@/services/projectService.js'

export default {
    name: 'ProjectsSection',
    components: {
        InteractiveMap
    },
    data() {
        return {
            projectCount: 0
        }
    },
    async mounted() {
        await this.loadProjectCount()
    },
    methods: {
        async loadProjectCount() {
            try {
                const projects = await projectService.fetchProjects()
                this.projectCount = projects.length
            } catch (error) {
                console.error('Failed to load project count:', error)
                this.projectCount = 0
            }
        },
        goToProjects() {
            this.$router.push('/projects')
        }
    }
}
</script>